const t = "styles-module__tabList___L4lgS", e = "styles-module__tabItems___T-8a4", _ = "styles-module__tabItem___2bM53", s = "styles-module__reverse___3960W", a = "styles-module__active___nPlLB", o = "styles-module__tabAdd___QLukv", l = "styles-module__tab___qkmxI", b = "styles-module__tabRemove___z4DGG", m = {
  tabList: t,
  tabItems: e,
  tabItem: _,
  reverse: s,
  active: a,
  tabAdd: o,
  tab: l,
  tabRemove: b
};
export {
  a as active,
  m as default,
  s as reverse,
  l as tab,
  o as tabAdd,
  _ as tabItem,
  e as tabItems,
  t as tabList,
  b as tabRemove
};
